// src/demo/seedMediaAssets.ts
//
// Phase M1: dev-first seeded assets.
// You can point these at:
// - public/ demo files (static)
// - Storage emulator paths (firebase)
// - Firestore registry keys (registry -> resolves to url or firebase)

import type { MediaAssetV1 } from "@/contracts/media/MediaAssetV1";
import { createOmniCineSeedMediaAssets } from "@/demo/omnicineDevAssetCatalog";

let seedMediaAssetsCache: MediaAssetV1[] | null = null;

export function getSeedMediaAssets(): MediaAssetV1[] {
  if (seedMediaAssetsCache) return seedMediaAssetsCache;

  seedMediaAssetsCache = [
    ...createOmniCineSeedMediaAssets(),
    {
      v: 1,
      id: "introTheme", // ✅ registry key
      label: "Intro Theme",
      kind: "audio",
      durSec: 6,
      ref: { v: 1, provider: "registry", key: "introTheme" },
      tags: ["demo", "audio", "identity"],
    },
    {
      v: 1,
      id: "click", // ✅ registry key
      label: "Click SFX",
      kind: "audio",
      durSec: 1,
      ref: { v: 1, provider: "registry", key: "click" },
      tags: ["demo", "audio", "sfx"],
    },
    {
      v: 1,
      id: "waves", // if you want clip mediaId to be "waves"
      label: "Demo Video — Waves",
      kind: "video",
      durSec: 8,
      ref: { v: 1, provider: "static", path: "/demo/waves.mp4" },
      tags: ["demo", "video"],
    },
  ];

  return seedMediaAssetsCache;
}
